import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './screens/login';
import UserTable from './screens/userTable';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Navigation />
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}


function Navigation() {
  const { isAuthenticated, logout } = useAuth();

  return (
    <nav>
      <ul>
        {!isAuthenticated ? (
          <Login />
        ) : <UserTable/>}
      </ul>
    </nav>
  );
}

export default App;
